export const WebTrackTopic = {
  AUTH_LOG: "auth_log",
  PRINTER_LOG: "printer_log",
  ERROR_LOG: "error_log",
};
